import { withTheme } from '../config';
import { Rating } from '@rneui/base/dist/Rating/Rating';
export { Rating };
export default withTheme(Rating, 'Rating');
